export type CardLanguage = 
  | 'japanese' 
  | 'english' 
  | 'korean' 
  | 'chinese_traditional' 
  | 'chinese_simplified'
  | 'french' 
  | 'german' 
  | 'spanish' 
  | 'italian' 
  | 'portuguese'
  | 'thai' 
  | 'indonesian';

export interface LanguageOption {
  value: CardLanguage;
  label: string;
  flag: string;
  region?: string;
}

export const POKEMON_LANGUAGES: LanguageOption[] = [
  { value: 'japanese', label: 'Japanese', flag: '🇯🇵', region: 'Asia' },
  { value: 'english', label: 'English', flag: '🇺🇸', region: 'International' },
  { value: 'korean', label: 'Korean', flag: '🇰🇷', region: 'Asia' },
  { value: 'chinese_traditional', label: 'Chinese (Traditional)', flag: '🇹🇼', region: 'Asia' },
  { value: 'chinese_simplified', label: 'Chinese (Simplified)', flag: '🇨🇳', region: 'Asia' },
  { value: 'french', label: 'French', flag: '🇫🇷', region: 'Europe' },
  { value: 'german', label: 'German', flag: '🇩🇪', region: 'Europe' },
  { value: 'spanish', label: 'Spanish', flag: '🇪🇸', region: 'Europe' },
  { value: 'italian', label: 'Italian', flag: '🇮🇹', region: 'Europe' },
  { value: 'portuguese', label: 'Portuguese', flag: '🇧🇷', region: 'Americas' },
  { value: 'thai', label: 'Thai', flag: '🇹🇭', region: 'Asia' },
  { value: 'indonesian', label: 'Indonesian', flag: '🇮🇩', region: 'Asia' },
];

export const LANGUAGE_LABELS: Record<CardLanguage, string> = {
  japanese: 'Japanese',
  english: 'English',
  korean: 'Korean',
  chinese_traditional: 'Chinese (Traditional)',
  chinese_simplified: 'Chinese (Simplified)',
  french: 'French',
  german: 'German',
  spanish: 'Spanish',
  italian: 'Italian',
  portuguese: 'Portuguese',
  thai: 'Thai',
  indonesian: 'Indonesian',
};
